import { useEffect, useState } from 'react';
import { signedFetch } from '../../super-picker/services/api';

export interface CurrentUserInfo {
  Name?: string;
  CEANumber?: string;
  Mobile?: string;
  Email?: string;
  Photo?: string;
}

export const useCurrentUser = (): CurrentUserInfo | null => {
  const [userInfo, setUserInfo] = useState<CurrentUserInfo | null>(null);

  useEffect(() => {
    signedFetch('/api/super-calculator/user/me')
      .then(async (response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch current user');
        }
        return response.json();
      })
      .then((user) => {
        setUserInfo({
          Name: user.Name ?? user.name,
          CEANumber: user.CEANumber ?? user.ceaNumber ?? user.identifier,
          Mobile: user.Mobile ?? user.mobile,
          Email: user.Email ?? user.email,
          Photo: user.Photo ?? user.photo,
        });
      })
      .catch(() => {
        // silently ignore — user info is optional for the PDF
      });
  }, []);

  return userInfo;
};
